import script from "./GestionUsuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionUsuarios.vue?vue&type=script&setup=true&lang=js"

import "./GestionUsuarios.vue?vue&type=style&index=0&id=8795ab16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8795ab16"]])

export default __exports__